import { translate } from '@jsverse/transloco';
export enum Day {
    SUNDAY = 'SUNDAY',
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
}

export class DayHelper {
    static getDayLocale(day: Day): string {
        switch (day) {
            case Day.SUNDAY:
                return translate('CORE.DAY.SUNDAY');
            case Day.MONDAY:
                return translate('CORE.DAY.MONDAY');
            case Day.TUESDAY:
                return translate('CORE.DAY.TUESDAY');
            case Day.WEDNESDAY:
                return translate('CORE.DAY.WEDNESDAY');
            case Day.THURSDAY:
                return translate('CORE.DAY.THURSDAY');
            case Day.FRIDAY:
                return translate('CORE.DAY.FRIDAY');
            case Day.SATURDAY:
                return translate('CORE.DAY.SATURDAY');
            default:
                return '';
        }
    }
}
